const config = {
 STUDIO_VERSION:'e519dec034734c16c89763596a4245429af7e7b5',
  NAME: 'Dev',
  TRACKING_ID: '',
  API_URL: 'https://dev-services.goodmaps.io/graphql',
};

export default config;
